var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('FlashMessage',{attrs:{"position":'right bottom'}}),_c('div',{staticClass:"bg-panel"}),(!_vm.loading)?[_c('header',{staticClass:"app-header"},[_c('NavMenu')],1),_c('main',{staticClass:"app-container"},[_c('router-view')],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }